import { render, staticRenderFns } from "./ProjectNew.vue?vue&type=template&id=2f78d182&"
import script from "./ProjectNew.vue?vue&type=script&lang=js&"
export * from "./ProjectNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports